import React from 'react';
import ReactDOM from 'react-dom';
import './styles/index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Contains test data, allowing you to skip set up. It's an array 
// so that you can save multiple common set ups without commenting in/out.
// Suppress eslint warnings for variable defined but unused; that way we 
// don't have to comment that section in/out all the time.
// eslint-disable-next-line
const devSetUp = [
  // Meltdown, one category
  {
    lang: "en",
    mode: "meltdown",
    role: "WO",
    categories: ["DEC"],
    lecture: null,
    teams: ["atomicStrikers", "spontaneousCombustibles"],
    firstPlayer: 0
  },
  {
    lang: "en",
    mode: "lecture",
    role: "WO",
    categories: ["DEC", "PCT", "ROR", "CPP", "PPE", "HAR", "TOX", "RAS", "HDA"],
    lecture: ["MC_1", "MCV_1","MC_8"],
    teams: ["atomicStrikers", "spontaneousCombustibles"],
    firstPlayer: 1
  }
]

ReactDOM.render(
  <React.StrictMode>
    <App 
      /** 
       * Comment the line below in/out to skip set up.
       * This is useful for both live and (theoretically) automated testing.
      **/
      // devSetUp={devSetUp[1]} 
    />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
